import { Directive, ElementRef, input, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormGroupDirective,
  Validators
} from '@angular/forms';

@Directive({
  selector: '[requiredAsterisk]'
})
export class RequiredAsteriskDirective implements OnInit {
  controlName = input<string>('', { alias: 'requiredAsterisk' });

  constructor(
    private _el: ElementRef,
    private _parent: FormGroupDirective
  ) {}

  ngOnInit() {
    const control: AbstractControl | null = this._parent.form.get(
      this.controlName()
    );
    const label: HTMLElement = this._el.nativeElement;
    const isRequired = control?.hasValidator(Validators.required);

    if (isRequired) {
      const star = document.createElement('span');
      star.textContent = ' *';
      star.style.color = 'red';
      label.appendChild(star);
    }
  }
}
